var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"mt-0 ma-4",attrs:{"flat":""}},[_c('v-card-text',[_c('div',{staticClass:"body-1 font-weight-bold mb-3"},[_vm._v("\n        Riwayat\n      ")]),(_vm.tabs === 1)?_c('div',[_c('Plafon',{attrs:{"detailCustomer":_vm.detailCustomer}})],1):_vm._e()])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }